import styled from 'styled-components'

export const WrapperFilter = styled.div`
  display: flex;
  padding: 20px;
  align-items: flex-end;
  justify-content: space-between;
`
export const WrappedButtons = styled.div`
  display: flex;
  justify-content: space-between;

  button {
    margin-left: .5rem;
  }
`
export const Input = styled.input`
  width: 268px;
`
